import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import ItemOverviewReport from '../../components/ItemOverviewReport';
import {
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/ItemOverviewDetails200Selectors';

function ItemOverviewDetails200Container(props) {
  return (
    <ItemOverviewReport
      reportId={ReportDefinitions.ITEM_OVERVIEW_DETAILS_200.id}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
  };
}

ItemOverviewDetails200Container.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default connect(mapStateToProps)(ItemOverviewDetails200Container);
